import { MapPin, Users, Award, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <div className="font-inter" data-testid="about-page">
      {/* Header */}
      <section className="bg-[#2B2B2B] text-white py-16" data-testid="about-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-poppins font-bold text-4xl md:text-5xl mb-4">
            About Sita Mani Global
          </h1>
          <div className="w-24 h-1 bg-[#B11217]"></div>
        </div>
      </section>

      {/* Who We Are */}
      <section className="py-16 bg-white" data-testid="who-we-are-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-6">
                Who We Are
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Sita Mani Global is a leading wooden pallet manufacturing company based in Gandhidham, Gujarat. We specialize in producing high-quality, ISPM-15 certified wooden pallets and export packaging solutions for businesses across India and international markets.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                With state-of-the-art manufacturing facilities and a team of experienced professionals, we deliver reliable, durable, and cost-effective packaging solutions that meet the highest industry standards.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our commitment to quality, customer satisfaction, and timely delivery has made us a trusted partner for businesses in warehousing, logistics, FMCG, pharmaceutical, and manufacturing sectors.
              </p>
            </div>
            <div>
              <img
                src="/assets/images/wooden-pallets-banner.jpeg"
                alt="Wooden Pallets Manufacturing"
                className="w-full h-auto rounded shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Key Stats */}
      <section className="py-16 bg-[#F2F2F2]" data-testid="key-stats-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div data-testid="stat-experience">
              <div className="w-20 h-20 bg-[#B11217] rounded-full flex items-center justify-center mx-auto mb-4">
                <Award size={40} className="text-white" />
              </div>
              <h3 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-2">10+</h3>
              <p className="text-gray-600">Years Experience</p>
            </div>

            <div data-testid="stat-clients">
              <div className="w-20 h-20 bg-[#B11217] rounded-full flex items-center justify-center mx-auto mb-4">
                <Users size={40} className="text-white" />
              </div>
              <h3 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-2">500+</h3>
              <p className="text-gray-600">Satisfied Clients</p>
            </div>

            <div data-testid="stat-capacity">
              <div className="w-20 h-20 bg-[#B11217] rounded-full flex items-center justify-center mx-auto mb-4">
                <TrendingUp size={40} className="text-white" />
              </div>
              <h3 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-2">50K+</h3>
              <p className="text-gray-600">Pallets/Month</p>
            </div>

            <div data-testid="stat-location">
              <div className="w-20 h-20 bg-[#B11217] rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin size={40} className="text-white" />
              </div>
              <h3 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-2">PAN India</h3>
              <p className="text-gray-600">Delivery Network</p>
            </div>
          </div>
        </div>
      </section>

      {/* Manufacturing Capability */}
      <section className="py-16 bg-white" data-testid="manufacturing-capability-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-8 text-center">
            Manufacturing Capability
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-[#F2F2F2] p-8">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-4">Advanced Infrastructure</h3>
              <p className="text-gray-600 leading-relaxed">
                Our manufacturing facility is equipped with modern machinery and technology, enabling us to produce high-volume orders with precision and consistency. We maintain strict quality control at every stage of production.
              </p>
            </div>
            <div className="bg-[#F2F2F2] p-8">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-4">Skilled Workforce</h3>
              <p className="text-gray-600 leading-relaxed">
                Our team comprises experienced craftsmen and quality control experts who ensure that every pallet meets international standards. We invest in continuous training to maintain excellence.
              </p>
            </div>
            <div className="bg-[#F2F2F2] p-8">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-4">Quality Raw Materials</h3>
              <p className="text-gray-600 leading-relaxed">
                We source premium quality wood from certified suppliers, ensuring durability and strength. Our materials undergo rigorous inspection before entering the production process.
              </p>
            </div>
            <div className="bg-[#F2F2F2] p-8">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-4">Custom Solutions</h3>
              <p className="text-gray-600 leading-relaxed">
                We offer customization in size, load capacity, and design to match specific client requirements. Our engineering team works closely with clients to develop optimal solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Location Advantage */}
      <section className="py-16 bg-[#F2F2F2]" data-testid="location-advantage-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="/assets/images/warehouse-packaging.jpeg"
                alt="Export and Logistics"
                className="w-full h-auto rounded shadow-lg"
              />
            </div>
            <div>
              <h2 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-6">
                Strategic Location Advantage
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Located in Gandhidham, Kutch - one of India's major trade and logistics hubs - we enjoy proximity to Kandla Port, facilitating seamless export operations and efficient supply chain management.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                This strategic location enables us to serve clients across Gujarat, Rajasthan, Maharashtra, and beyond, with reduced transit times and competitive logistics costs.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our connectivity to major highways and transportation networks ensures that your orders reach you on time, every time.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;